import React, { Component, Fragment } from "react";
import ModalVideo from "react-modal-video";
import ScrollToTop from "react-scroll-up";
import Slider from "react-slick";
import { slideSlick } from "../page-demo/script";
import ServiceList from "../elements/service/ServiceList";
import BlogContent from "../elements/blog/BlogContent";
import BrandTwo from "../elements/BrandTwo";
import PortfolioList from "../elements/portfolio/PortfolioList";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";
import CallAction from "../elements/callaction/CallAction";
import Team from "../elements/Team";
import Accordion01 from "../elements/Accordion";
import { FiCheck, FiChevronUp } from "react-icons/fi";
import Helmet from "../component/common/Helmet";

import about from "../assets/images/about/aboutImage.jpg";
import about2 from "../assets/images/about/aboutImage2.jpg";

const SlideList = [
  {
    textPosition: "text-left",
    bgImage: "bg_image--17",
    category: "Marketing Personal",
    title: "Impulsa tu marca.",
    description:
      "Soy un experto en marketing y estrategias de crecimiento, listo para llevar tu negocio al siguiente nivel.",
    buttonText: "Hablemos",
    buttonLink: "/contact",
  },
  {
    textPosition: "text-left",
    bgImage: "bg_image--18",
    category: "Estrategia",
    title: "Estrategias que transforman.",
    description:
      "Desarrollo planes personalizados que conectan con tu audiencia y potencian la identidad de tu marca.",
    buttonText: "Descubre más",
    buttonLink: "/service",
  },
  {
    textPosition: "text-left",
    bgImage: "bg_image--19",
    category: "Crecimiento",
    title: "Crece con confianza.",
    description:
      "Cada estrategia que implemento está diseñada para generar un crecimiento sostenible y medible en tu negocio.",
    buttonText: "Ver portafolio",
    buttonLink: "/portfolio",
  },
];

class Business extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.openModal = this.openModal.bind(this);
  }
  openModal() {
    this.setState({ isOpen: true });
  }
  render() {
    var namesItemOne = [
      "La Filosofía del Análisis de Negocios",
      "Acelera el Crecimiento de tu Marca",
      "Mitos y Verdades sobre el Marketing",
      "La Oferta Definitiva para Impulsar tu Negocio",
    ];

    var namesItemTwo = [
      "Evidencia de que el Marketing Funciona",
      "Acciones Clave para Potenciar tu Marca",
      "El Secreto Mejor Guardado del Marketing",
    ];

    const PostList = BlogContent.slice(0, 3);

    return (
      <Fragment>
        <Helmet pageTitle="Business" />
        <Header />
        {/* Start Slider Area   */}
        <div className="slider-wrapper">
          <div className="slider-activation">
            <Slider className="rn-slick-dot dot-light" {...slideSlick}>
              {SlideList.map((value, index) => (
                <div
                  className={`slide slide-style-2 d-flex align-items-center justify-content-center bg_image ${value.bgImage}`}
                  key={index}
                  data-black-overlay="8"
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className={`inner ${value.textPosition}`}>
                          {value.category ? <span>{value.category}</span> : ""}
                          {value.title ? (
                            <h1 className="title">{value.title}</h1>
                          ) : (
                            ""
                          )}
                          {value.description ? (
                            <p className="description">{value.description}</p>
                          ) : (
                            ""
                          )}
                          {value.buttonText ? (
                            <div className="slide-btn">
                              <a
                                className="rn-button-style--2 btn-solid"
                                href={`${value.buttonLink}`}
                              >
                                {value.buttonText}
                              </a>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
        {/* End Slider Area   */}

        {/* Start Brand Area */}
        <div className="rn-brand-area bg_color--5 ptb--60">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <BrandTwo />
              </div>
            </div>
          </div>
        </div>
        {/* End Brand Area */}

        {/* Start Service Area  */}
        <div className="service-area creative-service-wrapper ptb--120 bg_color--1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title service-style--3 text-center mb--30 mb_sm--0">
                  <h2 className="title">Nuestros Servicios</h2>
                  <p>
                    Existen diversas estrategias en el mundo del marketing, pero
                    la mayoría no logra transformar marcas de forma efectiva.
                    Descubre cómo implementamos soluciones personalizadas que
                    impulsan el crecimiento y la visibilidad de tu negocio.
                  </p>
                </div>
              </div>
            </div>
            <div className="row creative-service">
              <div className="col-lg-12">
                <ServiceList
                  item="6"
                  column="col-lg-4 col-md-6 col-sm-6 col-12 text-left"
                />
              </div>
            </div>
          </div>
        </div>

        {/* End Service Area  */}

        {/* Start About Area  */}
        <div className="rn-about-area ptb--120 bg_color--5">
          <div className="container">
            <div className="row row--35 align-items-center">
              <div className="col-lg-6">
                <div className="thumbnail">
                  <img
                    className="w-100"
                    src={about}
                    alt="Imágenes sobre Nosotros"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about-inner inner">
                  <div className="section-title">
                    <h2 className="title">Proceso de Trabajo</h2>
                    <p>
                      Descubre cómo fusionamos creatividad y estrategia para
                      transformar marcas. Nuestro enfoque se centra en generar
                      resultados tangibles que impulsan el crecimiento de tu
                      negocio.
                    </p>
                  </div>
                  <div className="accordion-wrapper mt--30">
                    <Accordion01 />
                  </div>
                  <div className="about-button mt--50">
                    <a className="rn-button-style--2 btn-solid" href="/about">
                      Mira cómo funciona
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* End About Area  */}

        {/* Start About Area  */}
        <div className="rn-about-area ptb--120 bg_color--1">
          <div className="container">
            <div className="row row--35 align-items-center">
              <div className="col-lg-6 order-2 order-lg-1">
                <div className="about-inner inner">
                  <div className="section-title">
                    <h2 className="title">Sobre Nosotros</h2>
                    <p className="description">
                      Nos especializamos en estrategias de marketing efectivas
                      que ayudan a las marcas a destacar. Nuestro enfoque
                      combina innovación, análisis y creatividad para generar
                      resultados medibles.
                    </p>
                  </div>
                  <div className="mt--30">
                    <h4>Nuestros Principios</h4>
                    <ul className="list-style--1">
                      {namesItemOne.map((name, index) => {
                        return (
                          <li key={index}>
                            <FiCheck /> {name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                  <div className="mt--30">
                    <h4>Qué Ofrecemos</h4>
                    <ul className="list-style--1">
                      {namesItemTwo.map((name, index) => {
                        return (
                          <li key={index}>
                            <FiCheck /> {name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 order-1 order-lg-2">
                <div className="thumbnail position-relative">
                  <img
                    className="w-100"
                    src={about2}
                    alt="Imágenes sobre nosotros"
                  />
                  <ModalVideo
                    channel="youtube"
                    isOpen={this.state.isOpen}
                    videoId="ZOoVOfieAF8"
                    onClose={() => this.setState({ isOpen: false })}
                  />
                 
                  <button
                    className="video-popup position-top-center theme-color"
                    onClick={this.openModal}
                  >
                    <span className="play-icon"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* End About Area  */}

        {/* Start Portfolio Area */}
        <div className="portfolio-area ptb--120 bg_color--5">
          <div className="portfolio-sacousel-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-title text-center service-style--3 mb--30 mb_sm--0">
                    <h2 className="title">Nuestros Proyectos</h2>
                    <p>
                      Cada proyecto es una oportunidad para innovar y ayudar a
                      las marcas a conectar mejor con su audiencia. Aquí puedes
                      ver algunos ejemplos de nuestro trabajo creativo.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <PortfolioList
                  styevariation="text-left mt--40"
                  column="col-lg-4 col-md-6 col-sm-6 col-12"
                  item="6"
                />
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="view-more-btn mt--60 text-center">
                    {/* <a
                      className="rn-button-style--2 btn-solid"
                      href="/portfolio"
                    >
                      <span>Ver Más Proyectos</span>
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* End Portfolio Area */}

        {/* Start Team Area  */}
        <div className="rn-team-area ptb--120 bg_color--1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title service-style--3 text-center mb--25 mb_sm--0">
                  <h2 className="title">Equipo de Expertos</h2>
                  <p>
                    Contamos con un equipo apasionado y altamente calificado,
                    enfocado en hacer crecer tu marca mediante estrategias de
                    marketing efectivas y personalizadas.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <Team column="col-lg-4 col-md-6 col-sm-6 col-12" />
            </div>
          </div>
        </div>

        {/* End Team Area  */}

        {/* Start Blog Area */}
        <div className="rn-blog-area pt--120 pb--80 bg_color--5">
          <div className="container">
            <div className="row align-items-end">
              <div className="col-lg-12">
                <div className="section-title service-style--3 text-center">
                  <h2 className="title">Últimas Tendencias en Marketing</h2>
                  <p>
                    Descubre las novedades más importantes sobre estrategias de
                    marketing digital, casos de éxito y consejos prácticos para
                    potenciar tu marca.
                  </p>
                </div>
              </div>
            </div>
            <div className="row mt--60">
              {PostList.map((value, i) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                  <div className="blog blog-style--1">
                    <div className="thumbnail">
                      <a href="/blog-details">
                        <img
                          className="w-100"
                          src={value.images}
                          alt="Imagen del Blog"
                        />
                      </a>
                    </div>
                    <div className="content">
                      <p className="blogtype">{value.category}</p>
                      <h4 className="title">
                        <a href="/blog-details">{value.title}</a>
                      </h4>
                      <div className="blog-btn">
                        {/* <div>
                        realmente deberia tener esto: href="/blog-details"
                          </div> */}
                        <a className="rn-btn text-white" >
                          Próximamente
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* End Blog Area */}

        {/* Start call To Action  */}
        <CallAction />
        {/* End call To Action  */}

        {/* Start Footer Style  */}
        <FooterTwo />
        {/* End Footer Style  */}

        {/* Start Back To Top */}
        <div className="backto-top">
          <ScrollToTop showUnder={160}>
            <FiChevronUp />
          </ScrollToTop>
        </div>
        {/* End Back To Top */}
      </Fragment>
    );
  }
}
export default Business;
